import { themeStyle } from '@src/theming';

import { TextInputTheme } from './types';

export const defaultTheme: TextInputTheme = {
  // size
  height: '40px',
  width: '100%',
  borderRadius: themeStyle.radiusMedium,

  // input
  color: themeStyle.varInkMedium,
  colorHover: themeStyle.varInkMedium,
  colorActive: themeStyle.varInkMain,
  backgroundColor: themeStyle.varBackgroundAlt,
  backgroundColorDark: null,
  backgroundColorHover: null,
  backgroundColorHoverDark: themeStyle.darkInkSuperLight,
  placeholderColor: null,

  border: '1px solid',
  borderColor: themeStyle.varInkLight,
  borderColorHover: themeStyle.transparent,
  borderColorActive: themeStyle.varInkLight,

  boxShadow: 'unset',
  hoverShadow: themeStyle.varShadowSmallFocus,
  innerPadding: '10px',

  // input text
  fontWeight: themeStyle.fontMedium,
  fontSize: themeStyle.fontSize14,
  lineHeight: '22px',
  textAlign: 'left',

  transition: '0.3s',

  icon: {
    height: '16px',
  },

  rightIcon: {
    height: '16px',
  },

  // error icon
  colorError: themeStyle.alertRed,
};

export const borderLessInputTheme: Partial<TextInputTheme> = {
  border: 'unset',
  backgroundColor: themeStyle.varInkSuperLight,
};

export const valueInputTheme: Partial<TextInputTheme> = {
  // size
  height: '30px',

  // input
  color: themeStyle.varInkMedium,
  colorHover: themeStyle.varInkMain,
  colorActive: themeStyle.varInkMain,
  backgroundColor: themeStyle.varInkBase,
  backgroundColorHoverDark: null,

  borderColor: themeStyle.varInkLight,
  borderColorHover: themeStyle.varInkLight,
  borderColorActive: themeStyle.varInkLight,

  hoverShadow: 'unset',
  innerPadding: '4px',

  // input text
  fontSize: themeStyle.fontSize12,
  lineHeight: '19px',
};

export const newTheme: Partial<TextInputTheme> = {
  placeholderColor: themeStyle.varInkLightMedium,
  letterSpacing: '-0.14px',
  lineHeight: '20px',
  boxShadow: 'unset',
  hoverShadow: 'unset',
  borderColorHover: themeStyle.varInkLight,
  outlineActive: `2px solid ${themeStyle.blueMedium}`,
  outlineOffset: '-2px',
  color: themeStyle.varInkMain,
  colorHover: themeStyle.varInkMain,
  innerPadding: '12px',
  caretColor: themeStyle.varInkMain,

  colorError: themeStyle.redMedium,
};
